export const getSelectableItemStyles = (_, { palette = {} }) => ({
  selectableButton: {
    padding: 0,
    height: 112,
    width: 140,
    cursor: 'pointer',

    '&:focus, &:hover, &:active': {
      outline: `1px solid ${palette.neutralPrimary}`,
      '& .shared-radio': {
        opacity: 1,
      },
    },
    '&.selected': {
      '& .shared-radio': {
        opacity: 1,
      },
      outline: `1px solid ${palette.themePrimary}`,
    },
    backgroundColor: palette.neutralLighter,
    marginRight: 2,
    outline: 'none',
    border: 'none',
    '& .shared-radio': {
      '&:focus, &:hover, &:active': {
        opacity: 1,
      },
      float: 'right',
      marginTop: '5px',
      marginLeft: '-25px',
      marginRight: '5px',
      position: 'relative',
      opacity: 0,
    },

    '& .icon-RadioBtnOff': {
      right: 5,
      zIndex: 1,
    },
    '&.wider-objective-item.objective-item': {
      width: 150,
    },
  },
});
